import React from 'react';
import { Col } from 'reactstrap';

export const InnerElementWrapper = (props) => {
    const { selectedElement, targetElement, selectedContainer, children } = props;
    return (
        <Col
            style={{
                width: "100%",
                display: "inline-flex",
                padding: '0px',
                border:
                    (selectedElement &&
                        targetElement.contentId ===
                        selectedElement.contentId) ||
                        (selectedContainer &&
                            targetElement.contentId ===
                            selectedContainer.contentId)
                        ? "1px solid #5593dc94"
                        : "0px solid transparent",
            }}
        >
            {children}
        </Col>
    )
}